import { render, staticRenderFns } from "./_get_loader.vue?vue&type=template&id=80ef4fd0&scoped=true"
var script = {}
import style0 from "./_get_loader.vue?vue&type=style&index=0&id=80ef4fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ef4fd0",
  null
  
)

export default component.exports